<template>
  <v-footer app padless absolute class="elShowWhenWebFlex">
    <div
      class="footer-wrap"
      :class="{ simplifyClass: this.$store.state.isSimplify }"
    >
      <div>
        ©{{ 2022 }} - {{ new Date().getFullYear() }} By
        {{ blogInfo.webSite.author }}
      </div>
      <!-- <a href="https://beian.miit.gov.cn/" target="_blank">
        {{blogInfo.webSite.recordNum}}
      </a> -->
    </div>
  </v-footer>
</template>

<script>
export default {
  computed: {
    isMessage() {
      return this.$route.path == "/message";
    },
    blogInfo() {
      return this.$store.state.blogInfo;
    },
  },
};
</script>

<style scoped>
.footer-wrap {
  width: 100%;
  line-height: 2;
  position: relative;
  padding: 40px 20px;
  color: #eee;
  font-size: 14px;
  text-align: center;
  background: linear-gradient(-45deg, #ee7752, #ce3e75, #23a6d5, #23d5ab);
  background-size: 400% 400%;
  animation: Gradient 10s ease infinite;
}
.footer-wrap a {
  color: #eee !important;
}
@keyframes Gradient {
  0% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>
